import { useDispatch, useSelector } from "react-redux";
import rsgGamesSlice from "./rsgGamesSlice";

function useRsgGames() {
  const { games, gameUrl } = useSelector((state) => {
    return state.rsgGames;
  });
  const dispatch = useDispatch();

  function setRsgGames(newRsgGames) {
    dispatch(rsgGamesSlice.actions.setRsgGames(newRsgGames));
  }

  function setRsgGameUrl(newRsgGameUrl) {
    dispatch(rsgGamesSlice.actions.setRsgGameUrl(newRsgGameUrl));
  }

  return { games, gameUrl, setRsgGames, setRsgGameUrl };
}

export default useRsgGames;
